import { render, staticRenderFns } from "./ActivateRegistration.vue?vue&type=template&id=461d999a&scoped=true&"
import script from "./ActivateRegistration.vue?vue&type=script&lang=js&"
export * from "./ActivateRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ActivateRegistration.vue?vue&type=style&index=0&id=461d999a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461d999a",
  null
  
)

export default component.exports